module.exports = __webpack_public_path__ + "img/職場日語.d86b7e03.png";